import {
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  Checkbox,
  CircularProgress,
  InputAdornment,
  FormControlLabel,
  TextField,
  useMediaQuery,
} from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import FlexView from 'react-flexview/lib'
import { AddComa, awaitWithLoading, showError } from '../../../services/utils'
import { OptionalTag } from '../../Core/OptionalTag'
import {
  SectionSelect,
  SectionSlider,
  SectionSpecialSelect,
  SectionTria,
} from '../../Core/Form/FormComponents'
import {
  SessionContextStore,
  SESSION_ACTIONS,
} from '../../../context/SessionContext'
import {
  BuyingInsuranceContextStore,
  OFFERS_ACTIONS,
} from '../../../context/BuyingInsuranceContext'
import { Action } from '../../../models/Action'
import { BackButton } from '../../Core/Buttons/BackButton'
import { ContinueButton } from '../../Core/Buttons/ContinueButton'
import { ReactComponent as ShieldSvg } from '../../../assets/shield_with_x.svg'
import {
  EventEmitterService,
  EventKey,
} from '../../../services/EventEmitterService'
import { PlansAndDurationSelect } from '../../Core/PlansAndDurationSelect'
import coveragesApi from '../../../api/coverages.api'
import { SkywatchDialog } from '../../PopUps/SkywatchDialog'
import { ElevatedCircle } from '../../Core/ElevatedCircle'
import NewFillButton from '../../Core/NewFillButton'
import { COVERAGE_TYPES } from '../../../models/insurance-models/CoverageType'
import { UserApi } from '../../../api/user.api'
import {
  NOT_COVERED_PER_PASS_LIABILITY_ID,
  BLACKLIST_COVERAGE_OPTIONS_AIRCRAFT_DAMAGE_LIABILITY,
} from '../../../Constants'
import { BottomSheetPolicySummary } from '../BottomSheetPolicySummary'
import { BrowserView, MobileView } from 'react-device-detect'
import DataLayerService from '../../../services/DataLayerService'
import CodeIcon from '@material-ui/icons/Code'
import { useForm } from 'react-hook-form'
import { useHistory } from 'react-router-dom'

export const CustomizeCoverages = () => {
  const history = useHistory()
  const sessionContext = React.useContext(SessionContextStore)
  const offersContext = React.useContext(BuyingInsuranceContextStore)
  const [timer, setTimer] = React.useState(null)
  const [showReferPopup, setShowReferPopup] = React.useState(false)
  const [showRedirectPopup, setShowRedirectPopup] = React.useState(false)
  const [open, setOpen] = React.useState(false)
  const [isAgree, setIsAgree] = React.useState(true)
  const isMobile = !useMediaQuery((theme) => theme.breakpoints.up('md'))
  const [aircraftDamageLiabilityOptions, setAircraftDamageLiabilityOptions] =
    React.useState(offersContext.options.aircraft_damage_liability)
  const [declineDeductibleReimbursement, setDeclineDeductibleReimbursement] =
    useState(false)

  const {
    register,
    formState: { errors, isValid },
    setError,
    clearErrors,
  } = useForm({ mode: 'onChange' })

  const changeDelay = (change) => {
    if (timer) {
      clearTimeout(timer)
      setTimer(null)
    }
    setTimer(
      setTimeout(() => {
        onPolicyFieldChange('additional_insured', change)
      }, 500)
    )
  }

  React.useEffect(() => {
    if (
      offersContext.offerCart.bodily_injury_liability ==
      NOT_COVERED_PER_PASS_LIABILITY_ID
    ) {
      setIsAgree(false)
      setOpen(true)
    } else {
      setIsAgree(true)
      setOpen(false)
    }
  }, [offersContext.offerCart.bodily_injury_liability])

  const onPolicyFieldChange = (name, value) => {
    let changed = { ...offersContext.offerCart }
    let pricebreakdown = { ...offersContext.pricebreakdown }
    changed[name] = value
    switch (name) {
      case 'period':
        if (changed[name]['plan'] != pricebreakdown['insuranceDuration']) {
          if (
            changed['period'].plan == 'Day' ||
            changed['period'].plan == 'Week'
          ) {
            changed.autoRenew = false
          } else changed.autoRenew = true

          if (
            changed['period'].plan != 'Year' &&
            pricebreakdown.insuranceDuration == 'Year'
          ) {
            let changedAircraftLimit =
              offersContext.options.aircraft_damage_liability.find(
                (i) => i.value === changed.aircraft_damage_liability
              )
            if (
              BLACKLIST_COVERAGE_OPTIONS_AIRCRAFT_DAMAGE_LIABILITY.includes(
                changedAircraftLimit.label
              )
            ) {
              changed.aircraft_damage_liability =
                offersContext.options.aircraft_damage_liability.find(
                  (i) => i.label === '$50,000'
                ).value
            }
          }
        }
        break
      case 'deductible_reimbursement':
        clearErrors('deductible_reimbursement')
        clearErrors('aircraft_damage_liability')
        const deductibleReimbursementLimit =
          offersContext.options.deductible_reimbursement.find(
            (i) => i.value === changed.deductible_reimbursement
          )
        const drLimit = parseInt(
          deductibleReimbursementLimit.label.substring(1)
        )
        const hullLimit = parseInt(
          offersContext.options.aircraft_damage_liability
            .find((i) => i.value === changed.aircraft_damage_liability)
            .label.substring(1)
        )
        if (deductibleReimbursementLimit.label === '$0') {
          setDeclineDeductibleReimbursement(true)
          if (hullLimit > 0) {
            setError('aircraft_damage_liability', {
              type: 'manual',
              message:
                'Please select a "Deductible Reimbursement" limit above $0 to enable "Damage to Non-Owned Aircraft"',
            })
          }
        } else {
          setDeclineDeductibleReimbursement(false)
          if (drLimit > hullLimit) {
            setError('aircraft_damage_liability', {
              type: 'manual',
              message:
                'The "Damage to Non-Owned Aircraft" value must be equal to or higher than the "Deductible Reimbursement" value.',
            })
          }
        }
        break
      case 'aircraft_damage_liability':
        clearErrors('deductible_reimbursement')
        clearErrors('aircraft_damage_liability')
        if (offersContext.options.deductible_reimbursement.length > 0) {
          const hull = offersContext.options.aircraft_damage_liability.find(
            (i) => i.value === changed.aircraft_damage_liability
          )
          const drLimit =
            offersContext.options.deductible_reimbursement.find(
              (i) => i.value === changed.deductible_reimbursement
            ) != null
              ? parseInt(
                  offersContext.options.deductible_reimbursement
                    .find((i) => i.value === changed.deductible_reimbursement)
                    .label.substring(1)
                )
              : 0
          const hullLimit = parseInt(hull.label.substring(1))

          if (drLimit === 0 && hullLimit > 0) {
            setError('aircraft_damage_liability', {
              type: 'manual',
              message:
                'Please select a "Deductible Reimbursement" limit above $0 to enable "Damage to Non-Owned Aircraft"',
            })
          } else if (drLimit > hullLimit) {
            setError('aircraft_damage_liability', {
              type: 'manual',
              message:
                'The "Damage to Non-Owned Aircraft" value must be equal to or higher than the "Deductible Reimbursement" value.',
            })
          }
        }
        break
      default:
        break
    }

    offersContext.dispatch(new Action('CART_CHANGED', changed))
    offersContext.dispatch(
      new Action('PRICE_BREAKDOWN_CHANGED', pricebreakdown)
    )
  }

  const onReferUnderwriterCommentsChange = (event) => {
    offersContext.dispatch(
      new Action(OFFERS_ACTIONS.REFER_COMMENTS, event.target.value)
    )
  }

  const getCoverageTooltip = (coverageName) => {
    if (coverageName == 'tria') {
      return 'Affords insurance in compliance with and to the extend required by the provisions of the federal Terrorism Rick Insurance Act of 2002, as amended.'
    } else if (coverageName == 'aircraft_damage_liability') {
      return "The Physical Damage to Non-Owned Aircraft coverage includes 'Loss of Use' of a non-owned aircraft, for which you are legally liable. The 'Loss of Use' limit of liability is included within the 'Damage Limit'. You must select a Damage Limit or decline this coverage to continue."
    }
    let value = offersContext.options[coverageName]
    return value && value.length > 1 ? value[0].tooltip : undefined
  }

  const onContinue = async () => {
    if (!isValid) {
      return false
    }
    const setQuoteCoverages = async () => {
        let offer = Object.assign({}, offersContext.offerCart);
        const start_date = offer.period.startDate
        const additional_insured = offer.additional_insured
        delete offer.vehicle_requests;
        delete offer.period;
        delete offer.additional_insureds;
        delete offer.additional_insured;
        delete offer.autoRenew;
        let res = await awaitWithLoading(coveragesApi.setCoverages({
            coverages: offer,
            additional_insured : additional_insured,
            start_date : start_date
            })
        )
        return true
    }
    await setQuoteCoverages()
    const fetchCoverageViolations = async () => {
      let res = await awaitWithLoading(
        coveragesApi.checkCoverageValidity(
          offersContext.offerCart.aircraft_damage_liability,
          offersContext.offerCart.period.plan,
          offersContext.offerCart.bodily_injury_liability,
          offersContext.pricebreakdown.price
        )
      )
      if (!res.ok) {
        EventEmitterService.dispatch(EventKey.ShowError, res)
        return false
      }
      return true
    }
    if (!isAgree) return

    if (
      offersContext.currentDisabledPlans.includes(
        offersContext.offerCart.period.plan
      )
    ) {
      DataLayerService.pushToDataLayer({
        event: 'state-pop-up',
        email: sessionContext.user.email,
      })
      showError(
        `This plan is currently unavailable in your state. to continue please select annual plan`
      )
      return
    }
    const res = await fetchCoverageViolations()
    if (!res) return

    const declinationsRes = await awaitWithLoading(UserApi.checkDeclinations())
    if (
      declinationsRes.ok &&
      !!declinationsRes.data &&
      declinationsRes.data.includes('declination')
    ) {
      await awaitWithLoading(sessionContext.loadUser())
      history.push('/declination')
    }
    // await checkProfileValidityAndFinishFlow();
    isMobile &&
      DataLayerService.pushToDataLayer({
        event: 'continue-button-at-customize',
      })
    EventEmitterService.dispatch(EventKey.FLOW_CUSTOMIZE_FINISH)
  }

  const handleDisagree = () => {
    setIsAgree(false)
    setOpen(false)
  }

  const handleAgree = async () => {
    setIsAgree(true)
    setOpen(false)
  }

  React.useEffect(() => {
    const calcOptionsAircraftDamageLiability = async () => {
      if (!offersContext.optionsLoaded) return
      let options = offersContext.options.aircraft_damage_liability.filter(
        (x) =>
          offersContext.offerCart.period.plan === 'Year' ||
          (offersContext.offerCart.period.plan != 'Year' &&
            !BLACKLIST_COVERAGE_OPTIONS_AIRCRAFT_DAMAGE_LIABILITY.includes(
              x.label
            ))
      )
      if (
        sessionContext.user.userInsuredPersons[0]?.pilot_certification.toLowerCase() ===
          'student' &&
        offersContext.offerCart.period.plan === 'Year'
      ) {
        const index = options.findIndex((obj) => obj.label === '$100000')
        options = index !== -1 ? options.slice(0, index + 1) : options
        var currDamageLiabilityIndex = options.findIndex(
          (obj) =>
            obj.value === offersContext.offerCart.aircraft_damage_liability
        )
        if (currDamageLiabilityIndex === -1) {
          //not in student options
          let changed = { ...offersContext.offerCart }
          changed.aircraft_damage_liability = options.find(
            (i) => i.label === '$50,000'
          ).value
          offersContext.dispatch(new Action('CART_CHANGED', changed))
        }
      }
      const updatedArray = options.map((item) => ({
        ...item,
        label: item.label.replace(/,/g, ''),
      }))
      setAircraftDamageLiabilityOptions(updatedArray)
    }
    calcOptionsAircraftDamageLiability()
  }, [
    offersContext.offerCart.period.plan,
    sessionContext.user.userInsuredPersons,
    offersContext.options.aircraft_damage_liability,
    offersContext.optionsLoaded,
  ])

  if (!offersContext.optionsLoaded)
    return (
      <div className="loading-coverages">
        <CircularProgress size="4rem" />
      </div>
    )
  return (
    <Container>
      <div className="text-title blue bold margin-bottom-basic">
        Customize Plan
      </div>
      <Divider />
      <PlansAndDurationSelect
        startingDate={offersContext.offerCart.period.startDate}
        endDate={offersContext.offerCart.period.endDate}
        disabledPlans={offersContext.currentDisabledPlans}
        activePlan={offersContext.offerCart.period.plan}
        allPlans={offersContext.allPlans}
        onChange={(plan, startDate, endDate) =>
          onPolicyFieldChange('period', {
            plan: plan,
            startDate: startDate,
            endDate: endDate,
          })
        }
      />

      <Divider />
      <SectionSpecialSelect
        onChange={onPolicyFieldChange}
        name="bodily_injury_liability"
        errors={offersContext.offerCardErrors}
        value={offersContext.offerCart.bodily_injury_liability}
        buttons={offersContext.options.bodily_injury_liability}
        tooltip={getCoverageTooltip('bodily_injury_liability')}
        title="Liability Insurance"
        subtitle="Insurance coverage that applies to bodily injury and property damage (excluding damage to non-owned aircraft)."
      />

      <SectionSelect
        divide={false}
        name="deductible_reimbursement"
        onChange={onPolicyFieldChange}
        errors={errors}
        value={offersContext.offerCart.deductible_reimbursement}
        buttons={
          declineDeductibleReimbursement
            ? offersContext.options.deductible_reimbursement
            : offersContext.options.deductible_reimbursement.filter(
                (option) => option.label !== '$0'
              )
        }
        tooltip={getCoverageTooltip('deductible_reimbursement')}
        title="Deductible Reimbursement"
        subtitle="Liability Insurance for Damage to Non-owned aircraft will reimburse the owner or lessor policy holder of the non-owned aircraft up to the physical damage deductible paid but not more than the deductible limit purchased."
      />
      {offersContext.options.deductible_reimbursement.length > 0 && (
        <>
          <FormControlLabel
            control={
              <Checkbox
                checked={declineDeductibleReimbursement}
                onChange={(_, checked) =>
                  onPolicyFieldChange(
                    'deductible_reimbursement',
                    checked
                      ? offersContext.options.deductible_reimbursement.find(
                          (x) => x.label === '$0'
                        ).value
                      : offersContext.options.deductible_reimbursement.find(
                          (x) => x.label === '$5,000'
                        ).value
                  )
                }
                color="primary"
              />
            }
            label="Decline deductible reimbursement"
            className="text-small gray margin-top-small"
          />
          <Divider />
        </>
      )}

      {isMobile ? (
        <SectionSelect
          name="aircraft_damage_liability"
          onChange={onPolicyFieldChange}
          errors={errors}
          value={offersContext.offerCart.aircraft_damage_liability}
          buttons={aircraftDamageLiabilityOptions}
          tooltip={getCoverageTooltip('aircraft_damage_liability')}
          title="Liability Insurance for damage to non-owned aircraft"
          subtitle="Insurance coverage that applies to damage that you are legally liable to pay as a result of damage to non-owned aircraft that is in your care."
        />
      ) : (
        <SectionSlider
          name="aircraft_damage_liability"
          title={'Liability Insurance for damage to non-owned aircraft'}
          subtitle={
            'Insurance coverage that applies to damage that you are legally liable to pay as a result of damage to non-owned aircraft that is in your care.'
          }
          value={offersContext.offerCart.aircraft_damage_liability}
          options={aircraftDamageLiabilityOptions}
          errors={errors}
          tooltip={getCoverageTooltip('aircraft_damage_liability')}
          onChange={(name, value) => {
            onPolicyFieldChange(
              name,
              offersContext.options.aircraft_damage_liability.find(
                (opt) => Number(opt.label.replace(',', '').slice(1)) == value
              ).value
            )
          }}
          marks={aircraftDamageLiabilityOptions.map((opt, index) => {
            if (
              index == aircraftDamageLiabilityOptions.length - 1 ||
              index == 0 ||
              index == Math.round(aircraftDamageLiabilityOptions.length / 2)
            )
              return {
                value: Number(opt.label.replace(',', '').slice(1)),
                label: '$' + AddComa(opt.label.replace(',', '').slice(1)),
              }
            else
              return {
                value: Number(opt.label.replace(',', '').slice(1)),
              }
          })}
          min={Number(
            offersContext.options.aircraft_damage_liability[0].label
              .replace(',', '')
              .slice(1)
          )}
          max={Number(
            aircraftDamageLiabilityOptions[
              aircraftDamageLiabilityOptions.length - 1
            ].label
              .replace(',', '')
              .slice(1)
          )}
        />
      )}
      {offersContext.offerCart.period.plan != 'Year' && (
        <div className="margin-top-basic margin-bottom-basic">
          <div className="up-sale-disclaimer">
            Short-term plans have a maximum hull limit of $60K, if you require a
            higher limit, please switch to the{' '}
            <span
              className="up-sale-disclaimer-underline"
              onClick={() => {
                onPolicyFieldChange('period', {
                  plan: 'Year',
                  startDate: offersContext.offerCart.period.startDate,
                  endDate: offersContext.offerCart.period.endDate,
                })
              }}>
              annual plan
            </span>
          </div>
        </div>
      )}

      <SectionSelect
        name="medical_payments"
        onChange={onPolicyFieldChange}
        errors={offersContext.offerCardErrors}
        value={offersContext.offerCart.medical_payments}
        buttons={offersContext.options.medical_payments}
        tooltip={getCoverageTooltip('medical_payments')}
        title="Medical Expense"
        subtitle="Insurance coverage that applies to reasonable medical expenses incurred within one year from the date of injury."
      />

      {/* <CustomizeAdditionalInsuredSection /> */}

      {sessionContext.user.insuranceType == COVERAGE_TYPES.PERSONAL && (
        <>
          <FlexView
            vAlignContent={'center'}
            className="space-between margin-top-basic">
            <FlexView vAlignContent={'center'}>
              <div className="text-body bold black">
                Add additional insured{' '}
              </div>
              {/* <AdditionalPopover /> */}
            </FlexView>
            <OptionalTag />
          </FlexView>
          <div className="text-small margin-bottom-small gray margin-top-6">
            Add an employer as an additional insured for an additional premium.
          </div>
          <Grid container>
            <Grid item xs={12} md={4}>
              <TextField
                defaultValue={offersContext.offerCart.additional_insured}
                onChange={(e) => changeDelay(e.target.value)}
                fullWidth
                variant="outlined"
                label={'Name'}
              />
            </Grid>
          </Grid>
          <Divider />
        </>
      )}

      <SectionTria
        name="tria"
        tooltip={getCoverageTooltip('tria')}
        title="COVERAGE FOR ACTS OF TERRORISM UNDER THE TERRORISM RISK INSURANCE ACT OF 2002 (AS AMENDED AND EXTENDED BY THE TERRORISM RISK INSURANCE EXTENSION ACT OF 2005 AND THE TERRORISM RISK INSURANCE PROGRAM REAUTHORIZATION ACTS OF 2007, 2015 AND 2019)"
        subtitle="Coverage provided for bodily injury and property damage for which you may be liable from certified acts of terrorism. This coverage is included in the Liability Insurance at no additional charge. "
        viewTria="View TERRORISM RISK INSURANCE ACT OF 2002 (As amended and extended by The Terrorism Risk Insurance Extension Act of 2005 and The Terrorism Risk Insurance Program Reauthorization Acts of 2007, 2015 and 2019) documentation"
        triaURL="https://www.skywatch.ai/tria"
      />

      <SkywatchDialog
        open={showRedirectPopup}
        maxWidth={isMobile ? 'md' : 'xs'}
        closeTitle={''}
        circleHeader={
          <ElevatedCircle>
            <CodeIcon className="blue" />{' '}
          </ElevatedCircle>
        }>
        <div className="text-title blue textcenter bold margin-bottom-basic">
          Your policy is under review
        </div>
        <div className="text-small">
          Our underwriters are checking your information, we will contact you as
          soon as we finish.
          <br />
          If you have any questions feel free to call our support team 1 (888)
          849-4902
        </div>
        <br />
        <br />
        <FlexView vAlignContent={'center'} hAlignContent={'center'}>
          <NewFillButton
            onClick={() => {
              window.location = 'https://www.skywatch.ai/aviation'
            }}
            flat>
            Ok
          </NewFillButton>
        </FlexView>
      </SkywatchDialog>

      <BrowserView>
        {isMobile && (
          <BottomSheetPolicySummary title={'Continue'} onClick={onContinue} />
        )}
        {!isMobile && (
          <FlexView vAlignContent={'center'}>
            <div className="margin-right-6">
              <BackButton />
            </div>
            <ContinueButton onClick={onContinue} />
          </FlexView>
        )}
      </BrowserView>
      <MobileView>
        <BottomSheetPolicySummary title={'Continue'} onClick={onContinue} />
      </MobileView>

      <Dialog
        open={open}
        onClose={handleDisagree}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">Warning</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            You have selected an option that will EXCLUDE passenger liability
            coverage. The coverage provided by the policy will NOT apply to any
            bodily injury claim made by an aircraft passenger.
            <br /> Is this the Liability Coverage you desire?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDisagree} color="primary">
            Cancel and return
          </Button>
          <Button onClick={handleAgree} color="primary" autoFocus>
            YES
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  )
}
